import React from 'react';
import { Tile as TileType } from './types';
import { getTileConfig } from './constants';

interface TileProps {
  tile: TileType;
  cellSize: number;
  gap: number;
}

const Tile: React.FC<TileProps> = ({ tile, cellSize, gap }) => {
  const config = getTileConfig(tile.value);

  const style: React.CSSProperties = {
    position: 'absolute',
    width: cellSize,
    height: cellSize,
    left: tile.col * (cellSize + gap) + gap,
    top: tile.row * (cellSize + gap) + gap,
    backgroundColor: config.backgroundColor,
    borderRadius: 6,
    transition: 'left 100ms ease-in-out, top 100ms ease-in-out',
    zIndex: tile.isMerged ? 10 : 1,
    overflow: 'hidden'
  };

  // Head image - larger, positioned in top-left area
  const imageStyle: React.CSSProperties = {
    position: 'absolute',
    width: '85%',
    height: '85%',
    objectFit: 'contain',
    left: '-5%',
    top: '5%'
  };

  // Number badge - bottom right corner with contrasting background
  const badgeSize = Math.max(cellSize * 0.38, 28);
  const labelContainerStyle: React.CSSProperties = {
    position: 'absolute',
    bottom: 4,
    right: 4,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: 4,
    padding: '2px 6px',
    minWidth: badgeSize * 0.6,
    textAlign: 'center'
  };

  const labelStyle: React.CSSProperties = {
    fontSize: Math.max(cellSize * 0.22, 14),
    fontWeight: 'bold',
    color: '#fff',
    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
  };

  const className = `alien2048-tile ${tile.isNew ? 'tile-new' : ''} ${tile.isMerged ? 'tile-merged' : ''}`;

  return (
    <div className={className} style={style}>
      <img
        src={config.image}
        alt={config.name}
        style={imageStyle}
        draggable={false}
      />
      <div style={labelContainerStyle}>
        <span style={labelStyle}>{tile.value}</span>
      </div>
    </div>
  );
};

export default Tile;
